/* Candy4U gift card FX 5: Magic card (sections/c4u-gift-fx-magic.liquid, assets/c4u-gift-fx-magic.css).
   Arsalan 2026-10-27: "add gifting animations in this pdp page, best 5 pages, best unique and amazing effects/animations
   about gifting ... dont edit existing, create 5 in live, i will check then choose".
   The client's own card becomes a premium holographic card. Nothing on the page is edited: this adds its own layers
   and listens on document, so it runs after the page's own handlers (assets/c4u-gift-card.js).
   - Always: the card leans toward the pointer (desktop) or floats (phones) under a foil, a glare and twinkling stars.
   - Intro: it flips in from edge-on with a shimmer and a ring of stars. Any tap skips it.
   - Amount: a full spin with a shimmer (it replaces the page's pop); mid-turn its back shows the new amount.
   - Recipient: the back is a gift tag that writes their name and message as they type and turns back 3s after.
     When the big card is off screen (phones), a small copy of the tag floats near the fields instead.
   - Add to basket: the card collapses into a shooting star that flies to the basket, over the drawer.
   - Below the band: the How it works and occasion cards lean toward the pointer with a glare (desktop). */
(function(){
  if(window.C4UFxMagic){ window.C4UFxMagic.boot(); return; }

  var D = document, DE = D.documentElement;
  function mq(q){ return window.matchMedia ? window.matchMedia(q) : { matches: false }; }
  var REDUCE = mq('(prefers-reduced-motion: reduce)').matches;
  var FINE = mq('(hover: hover) and (pointer: fine)');
  /* the visible card inside the client's PNG, measured on the 1600px file: 88.6% x 93.5% of it, centred */
  var VIS_W = 0.88625, VIS_H = 0.93533, ASPECT = 1.7506, RAD = 0.0705;
  var DEG = Math.PI / 180;
  var COLS = ['#FFFFFF', '#FF6FD8', '#FFD166', '#7AD7FF', '#FFFFFF', '#B13BFF', '#FF00B8'];
  var ctrls = [];
  var mouse = { x: 0, y: 0, on: false };

  function clamp(v, a, b){ return v < a ? a : v > b ? b : v; }
  function rnd(a, b){ return a + Math.random() * (b - a); }
  function pick(list){ return list[Math.floor(Math.random() * list.length)]; }
  function el(tag, cls, parent){
    var n = D.createElement(tag);
    if(cls) n.className = cls;
    if(parent) parent.appendChild(n);
    return n;
  }
  function deco(n){ n.setAttribute('aria-hidden', 'true'); return n; }
  function mod(a, m){ return ((a % m) + m) % m; }
  /* the smallest angle >= min that shows this face (0 front, 180 back) */
  function ahead(min, face){ return Math.ceil((min - face) / 360) * 360 + face; }

  /* CSS-style cubic-bezier, so the JS moves read like the stylesheet's */
  function bez(x1, y1, x2, y2){
    function c(a, b, t){ return ((1 - 3 * b + 3 * a) * t + (3 * b - 6 * a)) * t * t + 3 * a * t; }
    return function(x){
      if(x <= 0) return 0;
      if(x >= 1) return 1;
      var lo = 0, hi = 1, t = x;
      for(var i = 0; i < 22; i++){ if(c(x1, x2, t) < x) lo = t; else hi = t; t = (lo + hi) / 2; }
      return c(y1, y2, t);
    };
  }
  var EASE_SPIN = bez(.6, -.3, .3, 1.14);   /* winds back, turns, overshoots, settles */
  var EASE_FLIP = bez(.5, -.22, .28, 1.2);
  var EASE_ON = bez(.25, .5, .25, 1.08);    /* already turning: no wind-up, no hitch */
  var EASE_FLY = bez(.55, 0, .3, 1);
  var EASE_IN = bez(.55, 0, .9, .35);
  /* the intro's settle: a damped spring from rest, 0 to 1 with a little overshoot */
  function spring(t, z, w){
    if(t <= 0) return 0;
    var wd = w * Math.sqrt(1 - z * z);
    return 1 - Math.exp(-z * w * t) * (Math.cos(wd * t) + z * w / wd * Math.sin(wd * t));
  }
  /* the pointer lean: a live spring, so it eases in and out and can be nudged */
  function spr(){ return { x: 0, v: 0, to: 0 }; }
  function sstep(s, dt){
    var n = Math.ceil(dt / .016), h = dt / n;
    for(var i = 0; i < n; i++){ s.v += (110 * (s.to - s.x) - 15 * s.v) * h; s.x += s.v * h; }
  }

  /* ---------- the stars: drawn once per colour, then stamped (much cheaper than paths every frame) ---------- */
  var SPR = {};
  function rgba(hex, a){
    var n = parseInt(hex.slice(1), 16);
    return 'rgba(' + (n >> 16 & 255) + ',' + (n >> 8 & 255) + ',' + (n & 255) + ',' + a + ')';
  }
  function starSpr(col){
    if(SPR[col]) return SPR[col];
    var s = 96, m = s / 2, c = el('canvas'), g;
    c.width = c.height = s;
    g = c.getContext('2d');
    var glow = g.createRadialGradient(m, m, 0, m, m, m);
    glow.addColorStop(0, rgba(col, .55)); glow.addColorStop(.2, rgba(col, .16)); glow.addColorStop(1, rgba(col, 0));
    g.fillStyle = glow;
    g.fillRect(0, 0, s, s);
    /* four long, thin points: the classic sparkle */
    var R = m * .94, k = m * .13;
    g.beginPath();
    g.moveTo(m, m - R);
    g.quadraticCurveTo(m + k, m - k, m + R, m);
    g.quadraticCurveTo(m + k, m + k, m, m + R);
    g.quadraticCurveTo(m - k, m + k, m - R, m);
    g.quadraticCurveTo(m - k, m - k, m, m - R);
    var body = g.createRadialGradient(m, m, 0, m, m, R);
    body.addColorStop(0, '#fff'); body.addColorStop(.38, '#fff'); body.addColorStop(.6, rgba(col, 1)); body.addColorStop(1, rgba(col, .3));
    g.fillStyle = body;
    g.fill();
    g.beginPath();
    g.arc(m, m, m * .1, 0, 7);
    g.fillStyle = '#fff';
    g.fill();
    return (SPR[col] = c);
  }
  function dotSpr(col){
    var key = 'd' + col;
    if(SPR[key]) return SPR[key];
    var s = 48, m = s / 2, c = el('canvas'), g;
    c.width = c.height = s;
    g = c.getContext('2d');
    var r = g.createRadialGradient(m, m, 0, m, m, m);
    r.addColorStop(0, '#fff'); r.addColorStop(.18, rgba(col, .95)); r.addColorStop(.5, rgba(col, .25)); r.addColorStop(1, rgba(col, 0));
    g.fillStyle = r;
    g.fillRect(0, 0, s, s);
    return (SPR[key] = c);
  }
  function part(o){ o.age = 0; o.rot = o.rot || rnd(0, 1.6); o.a = o.a || 1; return o; }
  function stepParts(list, dt){
    for(var i = list.length - 1; i >= 0; i--){
      var p = list[i];
      p.age += dt;
      if(p.age >= p.life){ list.splice(i, 1); continue; }
      if(p.kind === 'in'){
        var e = EASE_IN(p.age / p.life);
        p.x = p.fx + (p.tx - p.fx) * e; p.y = p.fy + (p.ty - p.fy) * e;
      } else if(p.vx || p.vy){
        var d = Math.pow(p.drag || 1, dt);
        p.vx *= d; p.vy = p.vy * d + (p.grav || 0) * dt;
        p.x += p.vx * dt; p.y += p.vy * dt;
      }
      p.rot += (p.vr || 0) * dt;
    }
  }
  function drawPart(g, p, dpr){
    var k = p.age / p.life, a, s, w;
    if(p.kind === 'tw'){ w = Math.sin(Math.PI * k); a = w * w; s = p.size * (.3 + .7 * w); }
    else if(p.kind === 'in'){ a = Math.min(1, k * 3) * (1 - Math.pow(k, 5)); s = p.size * (1 - .35 * k); }
    else { a = Math.min(1, k * 10) * Math.pow(1 - k, 1.5); s = p.size * (1 - .5 * k); }
    a *= p.a;
    if(a < .01 || s < .5) return;
    var c = Math.cos(p.rot) * dpr, n = Math.sin(p.rot) * dpr;
    g.setTransform(c, n, -n, c, p.x * dpr, p.y * dpr);
    g.globalAlpha = a;
    g.drawImage(p.dot ? dotSpr(p.col) : starSpr(p.col), -s / 2, -s / 2, s, s);
  }
  function rrect(g, x, y, w, h, r){
    g.beginPath();
    g.moveTo(x + r, y);
    g.arcTo(x + w, y, x + w, y + h, r); g.arcTo(x + w, y + h, x, y + h, r);
    g.arcTo(x, y + h, x, y, r); g.arcTo(x, y, x + w, y, r);
    g.closePath();
  }

  /* ---------- the gift tag (the card's back, and the floating copy on phones) ---------- */
  var LOGO = '';
  function findLogo(){
    var img = D.querySelector('.custom-mm7v1__logo:not(.custom-mm7v1__logo--drawer) img') || D.querySelector('header a[href="/"] img');
    return img ? img.currentSrc || img.src : '';
  }
  function buildTag(n){
    n.className += ' c4u-fxm-tag';
    n.innerHTML = '<span class="c4u-fxm-tag__top"><img class="c4u-fxm-tag__logo" alt="" decoding="async"><i class="c4u-fxm-tag__eyelet"></i></span>'
      + '<span class="c4u-fxm-tag__mid"><span class="c4u-fxm-tag__eyebrow">A gift for you</span>'
      + '<span class="c4u-fxm-tag__to">To <b></b></span><span class="c4u-fxm-tag__msg"></span></span>'
      + '<span class="c4u-fxm-tag__foot"><b></b>Candy4U gift card</span>';
    var logo = n.querySelector('img');
    if(LOGO) logo.src = LOGO; else logo.parentNode.removeChild(logo);
    return { name: n.querySelector('.c4u-fxm-tag__to b'), msg: n.querySelector('.c4u-fxm-tag__msg'), amt: n.querySelector('.c4u-fxm-tag__foot b') };
  }
  function setTag(t, d){
    t.name.textContent = d.name || 'someone sweet';
    t.name.classList.toggle('is-empty', !d.name);
    t.msg.textContent = d.msg ? '“' + d.msg + '”' : 'A little note for them';
    t.msg.classList.toggle('is-empty', !d.msg);
    t.amt.textContent = d.amt;
  }

  /* ---------- the basket: the header icon if it is on screen, else the top-right corner ---------- */
  function basket(){
    var b = D.getElementById('cart-icon-bubble') || D.querySelector('.custom-hro47k__icon-btn[aria-label="Cart"]') || D.querySelector('header [aria-label="Cart"]');
    var vw = DE.clientWidth, vh = window.innerHeight;
    if(b){
      var r = b.getBoundingClientRect(), cs = window.getComputedStyle(b);
      if(r.width && r.bottom > 8 && r.top < vh - 8 && r.right > 8 && r.left < vw - 8 && cs.visibility !== 'hidden' && cs.display !== 'none'){
        return { x: r.left + r.width / 2, y: r.top + r.height / 2 };
      }
    }
    return { x: vw - Math.min(46, vw * .11), y: Math.min(46, vh * .06) };
  }

  /* ---------- ADD TO BASKET: the card collapses into a star that flies to the basket ----------
     A fixed canvas over the whole screen (z 10001, above the drawer), removed when the last spark fades. */
  function flyStar(from, img){
    var cv = deco(el('canvas', 'c4u-fxm-fly'));
    var g = cv.getContext('2d'), dpr = Math.min(2, window.devicePixelRatio || 1);
    var vw = DE.clientWidth, vh = window.innerHeight;
    cv.width = Math.round(vw * dpr); cv.height = Math.round(vh * dpr);
    cv.style.width = vw + 'px'; cv.style.height = vh + 'px';
    D.body.appendChild(cv);

    var parts = [], trail = [], t = 0, last = 0, landed = -1, flash = null;
    var p0 = { x: from.x + from.w / 2, y: from.y + from.h / 2 };
    var to = basket();
    var dx = to.x - p0.x, dy = to.y - p0.y, L = Math.max(1, Math.sqrt(dx * dx + dy * dy));
    /* it arcs away from the straight line, on the upper side, more on short (phone) trips */
    var nx = -dy / L, ny = dx / L;
    if(ny > 0 || (Math.abs(ny) < .2 && nx > 0)){ nx = -nx; ny = -ny; }
    var bulge = Math.max(L * .3, 90);
    var p1 = { x: p0.x + dx * .15 + nx * bulge, y: p0.y + dy * .15 + ny * bulge };
    var COLLAPSE = .36, dur = .62 + Math.min(.4, L / 2500);
    var size = clamp(from.w * .06, 18, 34);
    var nw = img.naturalWidth, nh = img.naturalHeight;

    function at(k, end){
      /* a cubic from the card to the basket; the end follows the icon if the header moves */
      var p2 = { x: end.x - dx * .3 + nx * bulge * .55, y: end.y - dy * .3 + ny * bulge * .55 };
      var u = 1 - k;
      return {
        x: u * u * u * p0.x + 3 * u * u * k * p1.x + 3 * u * k * k * p2.x + k * k * k * end.x,
        y: u * u * u * p0.y + 3 * u * u * k * p1.y + 3 * u * k * k * p2.y + k * k * k * end.y
      };
    }
    function frame(ts){
      var dt = last ? Math.min(.05, (ts - last) / 1000) : .016;
      last = ts; t += dt;
      g.setTransform(1, 0, 0, 1, 0, 0);
      g.clearRect(0, 0, cv.width, cv.height);
      var end = basket();

      /* 1. the card shrinks into a point of light, whitening as it goes */
      if(t < COLLAPSE && nw){
        var k = t / COLLAPSE, e = EASE_IN(k), s = 1 - .93 * e;
        var w = from.w * s, h = from.h * s, rot = -9 * DEG * e;
        g.setTransform(Math.cos(rot) * dpr, Math.sin(rot) * dpr, -Math.sin(rot) * dpr, Math.cos(rot) * dpr, p0.x * dpr, p0.y * dpr);
        g.globalCompositeOperation = 'source-over';
        g.globalAlpha = 1 - clamp((k - .5) / .5, 0, 1);
        g.save();
        rrect(g, -w / 2, -h / 2, w, h, w * RAD);
        g.clip();
        g.drawImage(img, nw * (1 - VIS_W) / 2, nh * (1 - VIS_H) / 2, nw * VIS_W, nh * VIS_H, -w / 2, -h / 2, w, h);
        g.globalCompositeOperation = 'lighter';
        g.globalAlpha = Math.min(1, e * 1.4) * (1 - clamp((k - .6) / .4, 0, 1));
        g.fillStyle = '#ffd6f2';
        g.fillRect(-w / 2, -h / 2, w, h);
        g.restore();
        if(Math.random() < .5){
          var a = rnd(0, Math.PI * 2);
          parts.push(part({ x: p0.x + Math.cos(a) * w * .45, y: p0.y + Math.sin(a) * h * .45, vx: -Math.cos(a) * 120, vy: -Math.sin(a) * 120, drag: .1, size: rnd(.5, 1) * size, life: rnd(.3, .5), col: pick(COLS) }));
        }
      }
      g.globalCompositeOperation = 'lighter';

      /* 2. the star flies on an arc, a tail and sparks behind it */
      var fk = clamp((t - COLLAPSE * .75) / dur, 0, 1);
      var grow = clamp((t - COLLAPSE * .45) / (COLLAPSE * .55), 0, 1);
      var head = at(EASE_FLY(fk), end);
      if(landed < 0){
        trail.push(head);
        if(trail.length > 18) trail.shift();
        if(fk > 0){
          for(var j = 0; j < 2; j++){
            parts.push(part({ x: head.x + rnd(-4, 4), y: head.y + rnd(-4, 4), vx: rnd(-50, 50), vy: rnd(-30, 60), drag: .3, grav: 40,
              size: rnd(.35, .75) * size, life: rnd(.45, .9), col: pick(COLS), dot: Math.random() < .35, vr: rnd(-3, 3) }));
          }
        }
        if(fk >= 1){
          landed = t;
          flash = { x: end.x, y: end.y };
          for(var i = 0; i < 18; i++){
            var b = i / 18 * Math.PI * 2 + rnd(-.12, .12), sp = rnd(150, 380);
            parts.push(part({ x: end.x, y: end.y, vx: Math.cos(b) * sp, vy: Math.sin(b) * sp, drag: .03, size: rnd(.55, 1.05) * size, life: rnd(.55, .95), col: pick(COLS), dot: i % 3 === 0, vr: rnd(-4, 4) }));
          }
        }
      } else if(trail.length){
        trail.shift();
      }
      g.lineCap = 'round';
      for(var q = 1; q < trail.length; q++){
        var tk = q / trail.length;
        g.setTransform(dpr, 0, 0, dpr, 0, 0);
        g.globalAlpha = tk * tk * grow;
        g.strokeStyle = tk > .7 ? '#ffffff' : tk > .35 ? '#FF6FD8' : '#B13BFF';
        g.lineWidth = size * .42 * tk;
        g.beginPath(); g.moveTo(trail[q - 1].x, trail[q - 1].y); g.lineTo(trail[q].x, trail[q].y); g.stroke();
        g.globalAlpha = tk * .22 * grow;
        g.strokeStyle = '#FF00B8';
        g.lineWidth = size * 1.3 * tk;
        g.stroke();
      }
      stepParts(parts, dt);
      for(var m = 0; m < parts.length; m++) drawPart(g, parts[m], dpr);
      if(landed < 0 && grow > 0){
        var hs = size * (2.6 + .5 * Math.sin(t * 22)) * grow;
        g.setTransform(dpr, 0, 0, dpr, 0, 0);
        g.globalAlpha = .55 * grow;
        g.drawImage(dotSpr('#FF00B8'), head.x - hs * 1.3, head.y - hs * 1.3, hs * 2.6, hs * 2.6);
        drawPart(g, { x: head.x, y: head.y, size: hs * 1.5, rot: t * 3, age: .5, life: 1, kind: 'tw', a: 1, col: '#FFFFFF' }, dpr);
      }
      /* 3. it lands: a flash of a star, a ring, sparks */
      if(flash){
        var lk = (t - landed) / .6;
        if(lk < 1){
          var fs = size * 7 * Math.sin(Math.PI * Math.min(1, lk * 1.15));
          drawPart(g, { x: flash.x, y: flash.y, size: fs, rot: lk * 45 * DEG, age: .5, life: 1, kind: 'tw', a: 1, col: '#FFFFFF' }, dpr);
          g.setTransform(dpr, 0, 0, dpr, 0, 0);
          g.globalAlpha = Math.pow(1 - lk, 1.4) * .9;
          g.strokeStyle = '#FF6FD8';
          g.lineWidth = 3 * (1 - lk) + .5;
          g.beginPath(); g.arc(flash.x, flash.y, size * (.4 + 2.4 * (1 - Math.pow(1 - lk, 3))), 0, 7); g.stroke();
        }
      }
      if(landed >= 0 && t - landed > .65 && !parts.length && !trail.length){
        if(cv.parentNode) cv.parentNode.removeChild(cv);
        return;
      }
      if(t > 6){ if(cv.parentNode) cv.parentNode.removeChild(cv); return; }
      window.requestAnimationFrame(frame);
    }
    window.requestAnimationFrame(frame);
  }

  /* ---------- THE BAND ---------- */
  function init(band){
    if(band.hasAttribute('data-c4u-fxm')) return null;
    var stage = band.querySelector('[data-c4ugc-stage]');
    if(!stage || !stage.querySelector('[data-card]')) return null;
    band.setAttribute('data-c4u-fxm', '');
    DE.classList.add('c4u-fxm-on');
    if(REDUCE) DE.classList.add('c4u-fxm-rm');
    if(!LOGO) LOGO = findLogo();

    var form = band.querySelector('[data-c4ugc-form]');
    var status = band.querySelector('[data-c4ugc-status]');
    var send = band.querySelector('[data-c4ugc-send]');
    var nameIn = band.querySelector('[data-c4ugc-in="name"]');
    var msgIn = band.querySelector('[data-c4ugc-in="message"]');
    var atc = band.querySelector('[data-c4ugc-atc]');
    var panel = band.querySelector('[data-c4ugc-to]');
    var variants = [];
    try{ variants = JSON.parse(band.querySelector('[data-c4ugc-variants]').textContent); }catch(err){}
    function onImg(){ return stage.querySelector('.c4ugc__card--on') || stage.querySelector('[data-card]'); }
    var shownId = onImg().getAttribute('data-card');

    /* the layers sit straight in the stage (not in a wrapper) so each blend mode mixes with the card picture */
    var back = deco(el('div', 'c4u-fxm-l c4u-fxm-back', stage));
    var tag = buildTag(back);
    var foil = deco(el('div', 'c4u-fxm-l c4u-fxm-foil', stage));
    el('i', 'c4u-fxm-foil__band', foil); el('i', 'c4u-fxm-foil__glit', foil); el('i', 'c4u-fxm-foil__lamp', foil);
    el('i', '', deco(el('div', 'c4u-fxm-l c4u-fxm-glare', stage)));
    var sheen = deco(el('div', 'c4u-fxm-l c4u-fxm-sheen', stage));
    el('i', '', sheen);
    var cv = deco(el('canvas', 'c4u-fxm-fx', stage));
    var g = cv.getContext('2d');

    var W = 0, H = 0, SW = 0, SH = 0, cvL = 0, cvT = 0, dpr = 1;
    var raf = 0, last = 0, T = 0, dead = false, inView = true, drawn = false;
    var F = 0, fl = null, holds = null, prevCos = 1, spinning = false;
    var intro = null, iRy = 0, iRx = 0, iS = 1, iY = 0;
    var tx = spr(), ty = spr(), eng = 0, lx = .3, ly = .25;
    var charge = null, ck = 0, parts = [], twAt = 0;
    var backSide = false, backTimer = 0, mini = null, miniTimer = 0;
    var st = stage.style, wrote = {};

    function set(k, v){ if(wrote[k] !== v){ wrote[k] = v; st.setProperty(k, v); } }
    function size(){
      var img = onImg(), iw = img.offsetWidth, ih = img.offsetHeight;
      if(!iw || !ih) return;
      /* a hair inside the picture's edge, so no layer peeks past the card's own anti-aliased corner */
      W = iw * VIS_W - 1.5; H = ih * VIS_H - 1.5;
      SW = stage.offsetWidth; SH = stage.offsetHeight;
      set('--fxm-w', W.toFixed(1) + 'px');
      set('--fxm-h', H.toFixed(1) + 'px');
      set('--fxm-p', Math.max(900, W * 2.6).toFixed(0) + 'px');
      /* the stars' canvas: the card plus a margin, cut at the screen's edges so it never makes the page scroll sideways */
      var r = stage.getBoundingClientRect(), vw = DE.clientWidth;
      var mx = W * .18, my = H * .32;
      var left = Math.max((SW - W) / 2 - mx, -r.left), right = Math.min((SW + W) / 2 + mx, vw - r.left);
      cvL = left; cvT = (SH - H) / 2 - my;
      dpr = Math.min(2, window.devicePixelRatio || 1);
      cv.style.left = cvL.toFixed(1) + 'px'; cv.style.top = cvT.toFixed(1) + 'px';
      cv.style.width = (right - left).toFixed(1) + 'px'; cv.style.height = (H + 2 * my).toFixed(1) + 'px';
      cv.width = Math.round((right - left) * dpr); cv.height = Math.round((H + 2 * my) * dpr);
      drawn = true;
    }
    function chosen(){
      var r = form && form.querySelector('input[name="id"]:checked'), id = r ? r.value : shownId;
      for(var i = 0; i < variants.length; i++){ if(String(variants[i].id) === String(id)) return variants[i]; }
      return null;
    }
    function fillTag(){
      var v = chosen();
      var d = {
        name: nameIn && !nameIn.disabled ? nameIn.value.trim() : '',
        msg: msgIn && !msgIn.disabled ? msgIn.value.trim() : '',
        amt: v ? String(v.price).replace(/[.,]00(?=\D*$)/, '') : ''
      };
      setTag(tag, d);
      if(mini) setTag(mini.tag, d);
    }
    function cardSeen(f){
      var r = stage.getBoundingClientRect();
      return r.height > 0 && (Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0)) / r.height >= f;
    }
    function wake(){ if(!raf && !dead) raf = window.requestAnimationFrame(frame); }
    function alive(){
      return !dead && !D.hidden && (intro || fl || charge || ck > .005 || parts.length || (inView && !REDUCE));
    }

    /* ---- the stars around the card (canvas coordinates: the card's centre is cx, cy) ---- */
    function edge(cx, cy, a, out){
      var c = Math.cos(a), s = Math.sin(a);
      var k = Math.min(W / 2 / Math.max(Math.abs(c), 1e-4), H / 2 / Math.max(Math.abs(s), 1e-4));
      return { x: cx + c * (k + out), y: cy + s * (k + out), c: c, s: s };
    }
    function ambient(dt, cx, cy){
      twAt -= dt;
      if(twAt > 0) return;
      var n = 0;
      for(var i = 0; i < parts.length; i++) if(parts[i].amb) n++;
      if(n >= (W > 500 ? 9 : 6)) return;
      twAt = rnd(.1, .38);
      var on = Math.random() < .22;
      var p = on ? { x: cx + rnd(-.44, .44) * W, y: cy + rnd(-.4, .4) * H } : edge(cx, cy, rnd(0, Math.PI * 2), rnd(-.03, .2) * H);
      parts.push(part({ x: p.x, y: p.y, kind: 'tw', amb: true, size: rnd(.04, .085) * W * (on ? .65 : 1), life: rnd(1.2, 2.5), col: pick(COLS), vr: rnd(-.7, .7), a: rnd(.7, 1) }));
    }
    function burst(n, speed){
      var cx = SW / 2 - cvL, cy = SH / 2 - cvT;
      for(var i = 0; i < n; i++){
        var p = edge(cx, cy, i / n * Math.PI * 2 + rnd(-.12, .12), -.04 * H), sp = rnd(.5, 1) * speed * H;
        parts.push(part({ x: p.x, y: p.y, vx: p.c * sp, vy: p.s * sp, drag: .1, size: rnd(.035, .07) * W, life: rnd(.8, 1.4), col: pick(COLS), vr: rnd(-2.5, 2.5), dot: i % 4 === 3 }));
      }
    }
    /* the intro's ring: stars all round the card's edge, flying out together so they read as one ring */
    function ring(){
      var cx = SW / 2 - cvL, cy = SH / 2 - cvT, n = W > 500 ? 30 : 22;
      for(var i = 0; i < n; i++){
        var p = edge(cx, cy, i / n * Math.PI * 2, 0), sp = H * (i % 2 ? .62 : .82);
        parts.push(part({ x: p.x, y: p.y, vx: p.c * sp, vy: p.s * sp, drag: .08, size: (i % 2 ? .05 : .075) * W, life: i % 2 ? 1 : 1.3, col: i % 3 ? '#FFFFFF' : pick(COLS), vr: 1.2, dot: i % 5 === 4 }));
      }
    }
    function sweep(){
      sheen.classList.remove('c4u-fxm-sheen--go');
      void sheen.offsetWidth;
      sheen.classList.add('c4u-fxm-sheen--go');
    }
    function clearHolds(){
      if(!holds) return;
      holds[0].classList.remove('c4u-fxm-hold');
      holds[1].classList.remove('c4u-fxm-wait');
      holds = null;
    }
    function flipTo(to, dur, ease, spin){ fl = { from: F, to: to, t: 0, dur: dur, ease: ease, spin: !!spin }; wake(); }

    /* ---- THE FRAME: every move adds up into one turn, written once as the stage's variables ---- */
    function frame(ts){
      raf = 0;
      if(dead) return;
      var dt = last && ts - last < 200 ? Math.min(.05, (ts - last) / 1000) : .016;
      last = ts; T += dt;
      var r = stage.getBoundingClientRect();
      var cx = r.left + r.width / 2, cy = r.top + r.height / 2;

      if(intro){
        intro.t += dt;
        var k = intro.t;
        iRy = -90 * (1 - spring(k, .55, 6.2));
        iRx = 14 * (1 - spring(k, .7, 5.6));
        iS = .86 + .14 * spring(k, .6, 6.4);
        iY = H * .05 * (1 - spring(k, .75, 5.4));
        if(!intro.sw && k > .3){ intro.sw = 1; sweep(); }
        if(!intro.ring && k > .36){ intro.ring = 1; ring(); }
        if(k > 1.7){ intro = null; iRy = iRx = iY = 0; iS = 1; stage.classList.remove('c4u-fxm-intro'); }
      }
      if(fl){
        fl.t += dt;
        var fk = Math.min(1, fl.t / fl.dur);
        F = fl.from + (fl.to - fl.from) * fl.ease(fk);
        if(fk >= 1){ F = mod(fl.to, 360); fl = null; spinning = false; stage.classList.remove('c4u-fxm-spin'); }
      }
      var cosF = Math.cos(F * DEG);
      if(holds && cosF < .05) clearHolds();
      if(spinning && prevCos <= 0 && cosF > 0){ sweep(); burst(14, .7); }
      prevCos = cosF;

      /* the lean: toward the mouse near the card (desktop), a gentle float otherwise */
      var fine = FINE.matches, e = 0, nx = 0, ny = 0;
      if(fine && mouse.on && W){
        nx = (mouse.x - cx) / (W / 2); ny = (mouse.y - cy) / (H / 2);
        var ox = Math.max(0, Math.abs(mouse.x - cx) - W / 2), oy = Math.max(0, Math.abs(mouse.y - cy) - H / 2);
        e = clamp(1 - Math.sqrt(ox * ox + oy * oy) / 300, 0, 1);
      }
      eng += (e - eng) * (1 - Math.exp(-dt * 5));
      tx.to = -clamp(ny, -1, 1) * 10 * e; ty.to = clamp(nx, -1, 1) * 10 * e;
      var lean = Math.sqrt(tx.to * tx.to + ty.to * ty.to);
      if(lean > 10){ tx.to *= 10 / lean; ty.to *= 10 / lean; }
      sstep(tx, dt); sstep(ty, dt);
      var fa = fine ? .4 * (1 - eng) : 1;
      var fy = Math.sin(T * 1.1) * H * .014 * fa;
      var frx = Math.sin(T * .9 + 1) * 1.6 * fa, fry = Math.sin(T * .73 + 2) * 2.8 * fa;
      var tw = intro ? clamp(intro.t / 1.5, 0, 1) : 1;

      if(charge){
        charge.t += dt;
        if(charge.t > 9 || (status && status.getAttribute('data-state') === 'error')) charge = null;
        else if(inView && Math.random() < dt * 30){
          var a = rnd(0, Math.PI * 2), o = edge(SW / 2 - cvL, SH / 2 - cvT, a, H * rnd(.32, .5)), t2 = edge(SW / 2 - cvL, SH / 2 - cvT, a, -H * .08);
          parts.push(part({ kind: 'in', fx: o.x, fy: o.y, tx: t2.x, ty: t2.y, x: o.x, y: o.y, size: rnd(.03, .055) * W, life: rnd(.45, .7), col: pick(COLS), vr: rnd(-3, 3) }));
        }
      }
      ck += ((charge ? 1 : 0) - ck) * (1 - Math.exp(-dt * (charge ? 5 : 7)));

      var lift = fl ? Math.sin(Math.PI * clamp(fl.t / fl.dur, 0, 1)) * (fl.spin ? .05 : .03) : 0;
      var turn = (ty.x + fry) * tw + iRy;
      var rx = iRx + (tx.x + frx) * tw - ck * 5;
      var ry = turn + F;
      /* the light: on the card where the mouse is; drifting across on phones */
      var tlx = fine ? .3 + Math.sin(T * .43) * .14 : .5 + Math.sin(T * .5) * .42;
      var tly = fine ? .25 + Math.sin(T * .37 + 1) * .1 : .32 + Math.sin(T * .41 + 1.3) * .2;
      if(e > 0){ tlx += (clamp(.5 + nx * .5, -.15, 1.15) - tlx) * e; tly += (clamp(.5 + ny * .5, -.15, 1.15) - tly) * e; }
      var le = 1 - Math.exp(-dt * 7);
      lx += (tlx - lx) * le; ly += (tly - ly) * le;
      var tilt = Math.min(1, Math.sqrt(rx * rx + turn * turn) / 12);
      set('--fxm-rx', rx.toFixed(2) + 'deg');
      set('--fxm-ry', ry.toFixed(2) + 'deg');
      set('--fxm-s', (iS * (1 + .025 * ck + lift)).toFixed(4));
      set('--fxm-y', (iY + fy - ck * H * .025).toFixed(2) + 'px');
      /* the bands repeat every .647 card widths along x (.6 on the 112deg line), so the shift wraps inside one period and
         the band layer always covers the card however far it turns */
      var per = W * .6471;
      set('--fxm-fx', (mod(turn / 10 * .36 * W + Math.sin(T * .21) * .12 * W, per) - per).toFixed(1) + 'px');
      set('--fxm-fy', (-rx / 10 * .22 * H).toFixed(1) + 'px');
      set('--fxm-qx', (clamp(turn, -15, 15) / 10 * .05 * W).toFixed(1) + 'px');
      set('--fxm-qy', (clamp(-rx, -15, 15) / 10 * .05 * H).toFixed(1) + 'px');
      set('--fxm-fo', (.26 + .3 * tilt + .3 * ck + lift * 4).toFixed(3));
      set('--fxm-gx', (lx * W).toFixed(1) + 'px');
      set('--fxm-gy', (ly * H).toFixed(1) + 'px');
      set('--fxm-go', (.3 + .45 * eng + .3 * ck).toFixed(3));

      /* the stars */
      var ccx = SW / 2 - cvL, ccy = SH / 2 - cvT;
      if(inView && !REDUCE && !intro) ambient(dt, ccx, ccy);
      stepParts(parts, dt);
      var glint = intro && Math.abs(iRy) > 50 ? (Math.abs(iRy) - 50) / 40 : 0;
      if(parts.length || glint || drawn){
        g.setTransform(1, 0, 0, 1, 0, 0);
        g.clearRect(0, 0, cv.width, cv.height);
        g.globalCompositeOperation = 'lighter';
        /* edge-on, the card is a line of light */
        if(glint){
          var gh = H * iS * .5;
          g.setTransform(dpr, 0, 0, dpr, 0, 0);
          var lg = g.createLinearGradient(0, ccy - gh, 0, ccy + gh);
          lg.addColorStop(0, 'rgba(255,111,216,0)'); lg.addColorStop(.5, 'rgba(255,255,255,1)'); lg.addColorStop(1, 'rgba(255,111,216,0)');
          g.strokeStyle = lg;
          g.globalAlpha = glint;
          g.lineWidth = 2.5;
          g.beginPath(); g.moveTo(ccx, ccy - gh + iY); g.lineTo(ccx, ccy + gh + iY); g.stroke();
          g.globalAlpha = glint * .3;
          g.lineWidth = 16;
          g.stroke();
        }
        for(var m = 0; m < parts.length; m++) drawPart(g, parts[m], dpr);
        drawn = !!(parts.length || glint);
      }
      if(alive()) raf = window.requestAnimationFrame(frame);
    }

    /* ---- INTRO: from edge-on, once the picture is ready; skipped if the card is not in view or the wait is long ---- */
    function reveal(){ DE.classList.remove('c4u-fxm-pre'); }
    function startIntro(){
      var r = stage.getBoundingClientRect();
      var seen = r.bottom > 0 && r.top < window.innerHeight;
      var shownAlready = window.getComputedStyle(stage).visibility === 'visible';
      if(REDUCE || !seen || shownAlready || !DE.classList.contains('c4u-fxm-pre')){ reveal(); wake(); return; }
      intro = { t: 0 };
      iRy = -90; iRx = 14; iS = .86; iY = H * .05;
      /* edge-on first, then visible: in the same task, so no frame shows the flat card */
      set('--fxm-ry', '-90deg');
      set('--fxm-rx', '14deg');
      set('--fxm-s', '.86');
      stage.classList.add('c4u-fxm-intro');
      reveal();
      wake();
    }
    function whenReady(cb){
      var img = onImg(), done = false;
      function go(){ if(!done){ done = true; cb(); } }
      if(img.complete && img.naturalWidth){ if(img.decode) img.decode().then(go, go); else go(); }
      else{ img.addEventListener('load', go); img.addEventListener('error', go); }
      /* a slow picture: no intro rather than a late one. The budget runs from when the stage was hidden, read off the
         CSS failsafe's own clock (the stylesheet shows the stage by itself at 2.2s) */
      var waited = 0;
      try{
        stage.getAnimations().forEach(function(a){ if(a.animationName === 'c4u-fxm-show') waited = a.currentTime || 0; });
      }catch(err){}
      setTimeout(function(){ if(!done){ done = true; reveal(); wake(); } }, Math.max(0, 1800 - waited));
    }
    function skip(){ if(intro){ intro.t = 9; wake(); } }

    /* ---- AMOUNT: a full turn; mid-turn the back shows the new amount, then the new card comes round ---- */
    function amount(){
      var img = onImg(), id = img.getAttribute('data-card');
      fillTag();
      if(id === shownId) return;
      var was = stage.querySelector('[data-card="' + shownId + '"]');
      shownId = id;
      if(REDUCE) return;
      skip();
      var seen = holds ? holds[0] : was;
      clearHolds();
      if(Math.cos(F * DEG) > .05 && seen && seen !== img){
        seen.classList.add('c4u-fxm-hold'); img.classList.add('c4u-fxm-wait');
        holds = [seen, img];
      }
      stage.classList.add('c4u-fxm-spin');
      spinning = true;
      var face = backSide ? 180 : 0, to = ahead(F + 200, face);
      if(fl && fl.to >= to && mod(fl.to, 360) === face){ wake(); return; }
      flipTo(to, .5 + (to - F) / 360 * .72, fl ? EASE_ON : EASE_SPIN, true);
    }

    /* ---- RECIPIENT: the back while they type, the front again 3s after ---- */
    function toBack(){
      if(backSide) return;
      backSide = true;
      skip();
      if(REDUCE){ stage.classList.add('c4u-fxm-showback'); return; }
      if(fl && mod(fl.to, 360) === 180) return;
      flipTo(ahead(F - 179, 180), .95, fl ? EASE_ON : EASE_FLIP);
    }
    function toFront(){
      if(!backSide) return;
      backSide = false;
      if(REDUCE){ stage.classList.remove('c4u-fxm-showback'); return; }
      flipTo(ahead(F + 1, 0), .95, fl ? EASE_ON : EASE_FLIP);
    }
    function showBack(){
      fillTag();
      clearTimeout(backTimer);
      backTimer = setTimeout(function(){ toFront(); hideMini(); }, 3000);
      if(cardSeen(.6)){ hideMini(); toBack(); }
      else{ toFront(); showMini(); }
    }
    function sendChanged(on){
      if(on){ showBack(); return; }
      clearTimeout(backTimer);
      toFront(); hideMini();
    }

    /* the floating copy: above or below the field they are in, never over it */
    function headerBottom(){
      var h = D.querySelector('.custom-mm7v1__bar');
      var b = h ? h.getBoundingClientRect().bottom : 0;
      return b > 0 ? b : 0;
    }
    function placeMini(){
      if(!mini) return;
      var vv = window.visualViewport, vw = vv ? vv.width : DE.clientWidth, vh = vv ? vv.height : window.innerHeight;
      var ox = vv ? vv.offsetLeft : 0, oy = vv ? vv.offsetTop : 0;
      var phone = DE.clientWidth <= 768;
      var w = phone ? Math.min(vw * .68, 290) : Math.min(stage.offsetWidth * .62, 330), h = w / ASPECT;
      var a = D.activeElement, f = (a && band.contains(a) && a !== D.body ? a : panel || atc).getBoundingClientRect();
      var x, y;
      if(phone){
        x = ox + (vw - w) / 2;
        var top = oy + Math.max(14, headerBottom() + 10);
        y = (f.top + f.bottom) / 2 - oy > vh * .45 ? top : oy + vh - h - 16;
      } else {
        var sr = stage.getBoundingClientRect();
        x = sr.left + sr.width / 2 - w / 2;
        y = clamp((f.top + f.bottom) / 2 - h / 2, 16, window.innerHeight - h - 16);
      }
      mini.node.style.setProperty('--fxm-mw', w.toFixed(1) + 'px');
      mini.node.style.transform = 'translate3d(' + x.toFixed(1) + 'px,' + y.toFixed(1) + 'px,0)';
    }
    function showMini(){
      clearTimeout(miniTimer);
      if(!mini){
        var n = deco(el('div', 'c4u-fxm-mini'));
        mini = { node: n, tag: buildTag(el('div', '', n)) };
        D.body.appendChild(n);
        fillTag();
        placeMini();
        void n.offsetWidth;
      }
      mini.node.classList.remove('c4u-fxm-mini--off');
      mini.node.classList.add('c4u-fxm-mini--on');
      placeMini();
    }
    function hideMini(){
      if(!mini || mini.node.classList.contains('c4u-fxm-mini--off')) return;
      var m = mini;
      m.node.classList.remove('c4u-fxm-mini--on');
      m.node.classList.add('c4u-fxm-mini--off');
      clearTimeout(miniTimer);
      /* gone from the page once it has turned away */
      miniTimer = setTimeout(function(){
        if(m.node.parentNode) m.node.parentNode.removeChild(m.node);
        if(mini === m) mini = null;
      }, 750);
    }

    /* ---- ADD TO BASKET: charge up while it posts; on success the card becomes the shooting star ---- */
    function submitted(){
      if(REDUCE || !status || status.getAttribute('data-state') === 'error' || !/\S/.test(status.textContent)) return;
      skip();
      charge = { t: 0 };
      wake();
    }
    function added(){
      var ours = !!charge;
      charge = null;
      clearTimeout(backTimer);
      if(backSide) toFront();
      hideMini();
      fillTag();
      if(!ours || REDUCE) return;
      var img = onImg();
      var r = stage.getBoundingClientRect();
      var card = { x: r.left + (r.width - W) / 2, y: r.top + (r.height - H) / 2, w: W, h: H };
      var vis = (Math.min(card.y + card.h, window.innerHeight) - Math.max(card.y, 0)) / card.h;
      var from = card;
      if(vis < .4){
        /* the card is off screen: a small one rises from the button instead */
        var b = (atc || stage).getBoundingClientRect(), w = Math.min(160, W * .45);
        from = { x: b.left + b.width / 2 - w / 2, y: b.top - w / ASPECT * .8, w: w, h: w / ASPECT };
      } else {
        sweep(); burst(12, .8);
        tx.v += 70;
      }
      flyStar(from, img);
      wake();
    }

    function destroy(){
      dead = true;
      if(raf) window.cancelAnimationFrame(raf);
      if(io) io.disconnect();
      if(ro) ro.disconnect();
      clearTimeout(backTimer);
      if(mini && mini.node.parentNode) mini.node.parentNode.removeChild(mini.node);
    }

    size();
    fillTag();
    var io = window.IntersectionObserver ? new IntersectionObserver(function(es){
      inView = es[es.length - 1].isIntersecting;
      if(inView) wake();
    }, { rootMargin: '60px 0px' }) : null;
    if(io) io.observe(stage);
    var ro = window.ResizeObserver ? new ResizeObserver(function(){ size(); wake(); }) : null;
    if(ro) ro.observe(stage);
    if(REDUCE){
      /* still: the foil and the glare rest where the light falls, nothing moves */
      set('--fxm-gx', (W * .3).toFixed(1) + 'px'); set('--fxm-gy', (H * .25).toFixed(1) + 'px');
      reveal();
    } else whenReady(startIntro);

    return {
      band: band, amount: amount, typed: showBack, send: sendChanged, submitted: submitted, added: added,
      skip: skip, wake: wake, destroy: destroy, place: function(){ placeMini(); }, resize: size
    };
  }

  /* ---------- BELOW THE BAND: the step and occasion cards lean toward the pointer, with a glare (desktop) ---------- */
  var TILT = '.c4ugcs__card, .c4ugcm__card';
  var tilts = [], tiltRaf = 0, tiltLast = 0, hover = null;
  function tiltSetup(){
    if(REDUCE || !FINE.matches) return;
    DE.classList.add('c4u-fxm-tilt');
    D.querySelectorAll(TILT).forEach(function(card){
      if(card.querySelector('.c4u-fxm-cg')) return;
      el('i', '', deco(el('span', 'c4u-fxm-cg', card)));
    });
  }
  function tiltOf(card){
    for(var i = 0; i < tilts.length; i++) if(tilts[i].el === card) return tilts[i];
    var s = { el: card, rx: 0, ry: 0, l: 0, ga: 0, gx: 0, gy: 0, trx: 0, try_: 0, tl: 0, tga: 0, tgx: 0, tgy: 0 };
    tilts.push(s);
    return s;
  }
  function tiltMove(x, y, target){
    if(!DE.classList.contains('c4u-fxm-tilt')) return;
    var card = target && target.closest ? target.closest(TILT) : null;
    if(card && DE.clientWidth <= 768) card = null;
    if(hover && hover !== card){ var o = tiltOf(hover); o.trx = o.try_ = o.tl = o.tga = 0; }
    hover = card;
    if(card){
      var s = tiltOf(card), r = card.getBoundingClientRect();
      var nx = clamp((x - r.left) / r.width * 2 - 1, -1, 1), ny = clamp((y - r.top) / r.height * 2 - 1, -1, 1);
      s.trx = -ny * 7; s.try_ = nx * 7; s.tl = 1; s.tga = 1;
      s.tgx = x - r.left; s.tgy = y - r.top;
      if(!s.ga){ s.gx = s.tgx; s.gy = s.tgy; }
    }
    if(!tiltRaf) tiltRaf = window.requestAnimationFrame(tiltFrame);
  }
  function tiltFrame(ts){
    tiltRaf = 0;
    var dt = tiltLast && ts - tiltLast < 200 ? Math.min(.05, (ts - tiltLast) / 1000) : .016;
    tiltLast = ts;
    var k = 1 - Math.exp(-dt * 9), kg = 1 - Math.exp(-dt * 14), busy = false;
    for(var i = tilts.length - 1; i >= 0; i--){
      var s = tilts[i], st = s.el.style;
      s.rx += (s.trx - s.rx) * k; s.ry += (s.try_ - s.ry) * k; s.l += (s.tl - s.l) * k; s.ga += (s.tga - s.ga) * k;
      s.gx += (s.tgx - s.gx) * kg; s.gy += (s.tgy - s.gy) * kg;
      var rest = !s.tl && Math.abs(s.rx) < .02 && Math.abs(s.ry) < .02 && s.l < .005 && s.ga < .005;
      if(rest){
        ['--fxm-tx', '--fxm-ty', '--fxm-tl', '--fxm-ga', '--fxm-gx', '--fxm-gy'].forEach(function(n){ st.removeProperty(n); });
        tilts.splice(i, 1);
        continue;
      }
      busy = true;
      st.setProperty('--fxm-tx', s.rx.toFixed(2) + 'deg');
      st.setProperty('--fxm-ty', s.ry.toFixed(2) + 'deg');
      st.setProperty('--fxm-tl', s.l.toFixed(3));
      st.setProperty('--fxm-ga', (s.ga * .85).toFixed(3));
      st.setProperty('--fxm-gx', s.gx.toFixed(1) + 'px');
      st.setProperty('--fxm-gy', s.gy.toFixed(1) + 'px');
    }
    if(busy) tiltRaf = window.requestAnimationFrame(tiltFrame);
  }

  /* ---------- wiring: on document, so the page's own handlers have already run ---------- */
  function ctrlFor(node){
    for(var i = 0; i < ctrls.length; i++) if(ctrls[i].band.contains(node)) return ctrls[i];
    return null;
  }
  function each(fn){ for(var i = 0; i < ctrls.length; i++) fn(ctrls[i]); }
  D.addEventListener('change', function(e){
    var t = e.target, c = t && t.nodeType === 1 ? ctrlFor(t) : null;
    if(!c) return;
    if(t.name === 'id' && t.type === 'radio') c.amount();
    else if(t.hasAttribute('data-c4ugc-send')) c.send(t.checked);
  });
  D.addEventListener('input', function(e){
    var t = e.target, key = t && t.getAttribute ? t.getAttribute('data-c4ugc-in') : null;
    if(key !== 'name' && key !== 'message') return;
    var c = ctrlFor(t);
    if(c) c.typed();
  });
  D.addEventListener('submit', function(e){
    var c = e.target && e.target.hasAttribute && e.target.hasAttribute('data-c4ugc-form') ? ctrlFor(e.target) : null;
    if(c) c.submitted();
  });
  D.addEventListener('candy:cart:added', function(){ each(function(c){ c.added(); }); });
  D.addEventListener('pointermove', function(e){
    if(e.pointerType === 'touch') return;
    mouse.x = e.clientX; mouse.y = e.clientY; mouse.on = true;
    each(function(c){ c.wake(); });
    tiltMove(e.clientX, e.clientY, e.target);
  }, { passive: true });
  D.addEventListener('mouseout', function(e){
    if(e.relatedTarget) return;
    mouse.on = false;
    tiltMove(0, 0, null);
  });
  /* any tap, key, wheel or touch skips the intro */
  ['pointerdown', 'keydown', 'wheel', 'touchstart'].forEach(function(n){
    window.addEventListener(n, function(){ each(function(c){ c.skip(); }); }, { passive: true, capture: true });
  });
  D.addEventListener('visibilitychange', function(){ if(!D.hidden) each(function(c){ c.wake(); }); });
  var placing = 0;
  function place(){
    if(placing) return;
    placing = window.requestAnimationFrame(function(){ placing = 0; each(function(c){ c.place(); }); });
  }
  window.addEventListener('scroll', place, { passive: true });
  D.addEventListener('focusin', place);
  if(window.visualViewport){
    window.visualViewport.addEventListener('resize', place);
    window.visualViewport.addEventListener('scroll', place);
  }

  function boot(){
    for(var i = ctrls.length - 1; i >= 0; i--){
      if(!DE.contains(ctrls[i].band)){ ctrls[i].destroy(); ctrls.splice(i, 1); }
    }
    var fresh = 0;
    D.querySelectorAll('[data-c4ugc]').forEach(function(b){
      var c = init(b);
      if(c){ ctrls.push(c); fresh++; }
    });
    tiltSetup();
    /* no new band to play the intro on (or a re-run): never leave the stage hidden */
    if(!fresh) DE.classList.remove('c4u-fxm-pre');
  }
  window.C4UFxMagic = { boot: boot };
  if(D.readyState === 'loading') D.addEventListener('DOMContentLoaded', boot); else boot();
  D.addEventListener('shopify:section:load', boot);
})();
